import { render, staticRenderFns } from "./SudokuApp.vue?vue&type=template&id=73eb1ac8&"
import script from "./SudokuApp.vue?vue&type=script&lang=js&"
export * from "./SudokuApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports